// src/config.js
export const SITE_CONFIG = {
  ASSISTANT: { ENABLED: true },
  SITE_ID: 't.doan.la',
  LISTING_PREVIEWS_ENABLED: true,
  BASE_URL: 'https://trucdoan.com',
  // Amplify build webhook — fired by BlogManager on publish/edit/delete so new
  // posts get regenerated as crawlable static HTML (see triggerRebuild).
  AMPLIFY_WEBHOOK: 'https://webhooks.amplify.us-east-1.amazonaws.com/prod/webhooks?id=6a472aa9-0846-4432-aee9-394213c7a569&token=m3sgd1q61Z1hjf50fEpiZEIo6srI4Z6WVFUQP3fVw&operation=startbuild',
  STATE: 'CA', // limits to cali
  AGENT: {
    MLS_ID: '02060851',
    NAME: 'Truc Doan',
    EMAIL: 'doanestate@gmail.com',
    PHONE: '(818) 818-0989',
    BROKERAGE: 'VUI GROUP',
    LICENSE: '02060851',
    BROKERAGE_LICENSE: '02201290',
    OFFICE_CITY: 'Westminster',
    OFFICE_STATE: 'California',
    GOOGLE_REVIEW: 'https://www.google.com/search?sca_esv=9a0f969563c68435&rlz=1C5OZZY_enUS1164US1164&sxsrf=ANbL-n5zdRuWfd5Io9qbcQ2Wn0V7xYejHg:1773859826022&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qOchBbDIMD4ESs307ZRZgv0rOTtCohwoHKAAsUTUYzD_Y0-72VlVBJKXMFZuRXLSEFvQYIqIFqEItBUAPn8e7RoMMBfaT1UjO0S-qask7W1AlRzKIoyFXuMmKY6lDXFyymAPvJvQ%3D&q=Truc+Doan+-+B%C3%A1n+nh%C3%A0+gi%C3%A1+t%E1%BB%91t+Reviews&sa=X&ved=2ahUKEwiCtr7mjqqTAxXSmGoFHdSMFLUQ0bkNegQIOBAF'
  }
};
